import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { kitchenService } from '../services';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isRegistered, setIsRegistered] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkRegistrationStatus();
  }, []);

  const checkRegistrationStatus = async () => {
    // First check if user has authentication token
    const token = localStorage.getItem('kitchenAuthToken');
    
    if (!token) {
      // No token, redirect to registration
      console.log('[ProtectedRoute] No auth token found, redirecting to registration');
      setIsRegistered(false);
      setLoading(false);
      return;
    }

    // Token exists, check restaurant registration status
    try {
      const response: any = await kitchenService.getRestaurantDetails();
      console.log('[ProtectedRoute] Restaurant details response:', response);
      
      if (response?.status && response?.data) {
        const step = response.data.step || 0;
        
        if (step >= 8) {
          // All steps completed
          console.log('[ProtectedRoute] Registration complete (step >= 8)');
          setIsRegistered(true);
          localStorage.setItem('kitchenRegistered', 'true');
        } else {
          // Incomplete registration
          console.log('[ProtectedRoute] Registration incomplete, step:', step);
          setIsRegistered(false);
        }
      } else {
        // No restaurant data, needs registration
        console.log('[ProtectedRoute] No restaurant data found');
        setIsRegistered(false);
      }
    } catch (error) {
      console.log('[ProtectedRoute] Error fetching restaurant details:', error);
      // On error, check localStorage as fallback
      const localStatus = localStorage.getItem('kitchenRegistered');
      setIsRegistered(localStatus === 'true');
    }
    
    setLoading(false);
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!isRegistered) {
    return <Navigate to="/kitchen-registration" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
